import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'react-flexbox-grid';
import {Spacer} from 'layout/util'
import FillRestWithLine from 'pages/june-5/components/text-and-line'
import AnnotationsList from 'components/interactive/annotation/AnnotationsList';
import {FromThem, FromMe, Clear, Section} from 'components/static/iMessageStyles'

const Title = styled.h2`
	display: inline-block;
	color: #333;
	margin: 10px 0;
`;

const IMessageBlock = (props) => {
	const {title, messages} = props.data;
	const { showAnnos, pageId, loggedInUserId, authorUserId, sectionId } = props.annoData;
	let lastSender = null;
	const conversation = messages.map( (message, i) => {
		let conditionalClear = null;
		let msg = null;
		if (lastSender !== message.from) {
			conditionalClear = <Clear/>
		}
		lastSender = message.from;

		switch(message.from) {
			case "them":
				msg = <FromThem>{message.body}</FromThem>
				break;
			case "me":
				msg = <FromMe>{message.body}</FromMe>
				break;
			case "me-no-bg":
				msg = <FromMe style={{background:'none'}}>{message.body}</FromMe>
				break;
			default:
				break;
		}
		return (
			<React.Fragment key={i}>
				{conditionalClear}
				{msg}
			</React.Fragment>
		)
	})
	return(
		<Row>
	    <Col 
	    	xsOffset={1} xs={10} 
	      smOffset={2} sm={8} 
	      mdOffset={showAnnos?1:3} md={showAnnos?5:6} 
	      lgOffset={showAnnos?1:3} lg={showAnnos?5:6}
	    >
	    	<Spacer height={40}/>
				<FillRestWithLine trigger={showAnnos}>				
					<Title>{title}</Title>
				</FillRestWithLine>				
				<Section>
					{conversation}
				</Section>
			</Col>
			{showAnnos && 
		    <Col 
		    	xsOffset={1} xs={10} 
		      smOffset={2} sm={8} 
		      mdOffset={1} md={4} 
		      lgOffset={1} lg={4}
		    >
		    	<Spacer height={30}/>
					<AnnotationsList
            pageId={pageId}
            loggedInUserId={loggedInUserId}
            authorUserId={authorUserId}
            sectionId={sectionId}
          />
				</Col>
			}
		</Row>
	);
}

export default IMessageBlock


// WEBPACK FOOTER //
// ./src/pages/june-5/props/components/iMessageBlock.js